<template>
  <div class="pack_selector_container categories gap-10 lg-hide" v-dragscroll>
    <NuxtLinkLocale
      :to="`/${currentGameSlug}`"
      exact-active-class="active"
      class="pack_selector justify-start gap-10"
    >
      <services-icon />
      <h3 class="white-space-no medium-l font-family-2 pack-title f-w-500">
        {{ $t("new.services") }}
      </h3>
    </NuxtLinkLocale>

    <div
      class="d-flex-column justify-start lg-col-to-row gap-10"
      v-for="category in gameCategories"
      :key="category"
    >
      <div
        class="d-flex-column justify-start align-start gap-0"
        v-if="
          category.slug !== 'wow-raid-boost' && category.slug !== 'buy-wow-gold'
        "
      >
        <!-- DIRECT LINK TO CATEGORY -->

        <NuxtLinkLocale
          class="d-flex-row flex-1 pack_selector justify-start"
          role="button"
          :to="`/${currentGameSlug}/${category.slug}`"
          :class="[currentOpenDrop === category.slug && 'active']"
          v-if="!isNotCategoryPage"
        >
          <div class="d-flex-row justify-start flex-8">
            <pv-e-icon v-if="category.slug === 'wow-pve-boost'" />
            <pv-p-icon v-if="category.slug === 'wow-pvp-boost'" />
            <collection-icon v-if="category.slug === 'wow-collections'" />
            <gold-icon v-if="category.slug === 'buy-wow-gold'" />
            <h3
              class="white-space-no medium-l font-family-2 pack-title f-w-500"
            >
              {{ category.short_title }}
            </h3>
          </div>
          <div
            class="d-flex-row justify-end flex-2"
            v-if="isDropCategory(category)"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="plus"
              width="10"
              height="10"
              viewBox="0 0 160 160"
              fill="#9A9A9A"
              :class="[currentOpenDrop === category.slug && 'minus']"
            >
              <rect class="vertical-line" x="70" width="20" height="160" />
              <rect class="horizontal-line" y="70" width="160" height="20" />
            </svg>
          </div>
        </NuxtLinkLocale>

        <!-- OPENS CATEGORY PACKS-->
        <button
          class="d-flex-row flex-1 pack_selector justify-start"
          role="button"
          @click="openCategoryDrop(category.slug)"
          :class="[currentOpenDrop === category.slug && 'active']"
          v-if="isNotCategoryPage"
        >
          <div class="d-flex-row justify-start flex-8">
            <pv-e-icon v-if="category.slug === 'wow-pve-boost'" />
            <pv-p-icon v-if="category.slug === 'wow-pvp-boost'" />
            <collection-icon v-if="category.slug === 'wow-collections'" />
            <gold-icon v-if="category.slug === 'buy-wow-gold'" />
            <h3
              class="white-space-no medium-l font-family-2 pack-title f-w-500"
            >
              {{ category.short_title }}
            </h3>
          </div>
          <div
            class="d-flex-row justify-end flex-2"
            v-if="isDropCategory(category)"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="plus"
              width="10"
              height="10"
              viewBox="0 0 160 160"
              fill="#9A9A9A"
              :class="[currentOpenDrop === category.slug && 'minus']"
            >
              <rect class="vertical-line" x="70" width="20" height="160" />
              <rect class="horizontal-line" y="70" width="160" height="20" />
            </svg>
          </div>
        </button>

        <!-- CATEGORY LIST -->
        <ul
          class="mmo_category_list"
          :class="[currentOpenDrop === category.slug && 'opened']"
        >
          <li v-for="pack in category.packs" :key="pack.id">
            <router-link
              :to="getLink(category.slug, pack.slug)"
              class="height-36 other dark plain hover full-width justify-start t-light medium-l font-family-2 f-w-500 b-radius-6"
              exact-active-class="active_tab"
              :class="[getComingSoon(pack) && 'disabled']"
            >
              {{ pack.short_title }}
            </router-link>
          </li>
        </ul>
      </div>

      <NuxtLinkLocale
        v-else-if="category.slug === 'buy-wow-gold'"
        class="d-flex-row justify-start flex-8 pack_selector"
        :to="`/${currentGameSlug}/${category.slug}`"
        exact-active-class="active"
      >
        <gold-icon v-if="category.slug === 'buy-wow-gold'" />
        <h3 class="white-space-no medium-l font-family-2 pack-title f-w-500">
          {{ category.short_title }}
        </h3>
      </NuxtLinkLocale>
    </div>

    <button
      class="full-width primary align-start custom_order_mmo regular-m font-family-1 b-radius-6 f-w-600"
      style="margin-top: 12px"
      @click="handleTidio"
      v-if="$route.params?.gamePackSlug !== 'buy-wow-gold'"
    >
      <p class="f-w-600" style="text-align: left">
        {{ $t("new.need_custom_order") }}
      </p>
      <span class="regular-m t-grey font-famil-2">{{
        $t("contact.contact_us")
      }}</span>
      <img
        src="/images/games/world-of-warcraft-boost/custom_order_icon.webp"
        alt="custom_order_icon"
        class="custom_order_icon"
        height="72"
        width="54"
      />
    </button>

    <button
      class="full-width primary align-start custom_order_mmo regular-m font-family-1 b-radius-6 f-w-600"
      style="margin-top: 12px"
      @click="handleTidio"
      v-if="$route.params?.gamePackSlug === 'buy-wow-gold'"
    >
      <p class="f-w-600" style="text-align: left">
        {{ $t("new.become_gold_seller") }}
      </p>
      <span class="regular-m t-grey font-famil-2">{{
        $t("contact.contact_us")
      }}</span>
      <img
        src="/images/games/world-of-warcraft-boost/become_gold_seller_icon.webp"
        alt="custom_order_icon"
        class="custom_order_icon gold"
        height="72"
        width="54"
      />
    </button>
    <TpReviews class="xl-hide" v-if="!$isMobile()" />
  </div>

  <div class="d-flex-column gap-0 justify-start align-start above-lg-hide">
    <!-- DROPDOWN SELECTOR -->
    <div
      class="pack_selector_dropdown d-flex-row above-lg-hide"
      v-click-outside="closeOutside"
      v-if="false"
    >
      <button
        class="primary dark plain hover active_tab medium height-48 b-radius-6 full-width space-between medium-xl font-family-2 f-w-500"
        :class="[isOpen && 'opened']"
        @click.stop="toggleDrop"
        v-if="activePack"
      >
        {{ activePack }}
        <chev-right />
      </button>
      <transition name="slide-fade-top">
        <div
          class="d-flex-column justify-start align-start packs_list gap-18"
          v-if="isOpen"
        >
          <NuxtLinkLocale
            :to="
              pack?.is_service
                ? `/${currentGameSlug}`
                : getLinkMobile(pack.slug)
            "
            v-for="(pack, index) in otherPacks"
            class="medium-xl font-family-2 t-light routes d-flex-column align-start justify-start"
          >
            {{ pack.short_title }}
            <hr class="horizontal" v-if="index !== otherPacks.length - 1" />
          </NuxtLinkLocale>
        </div>
      </transition>
    </div>

    <TpReviews v-if="$isMobile()" />
  </div>
</template>

<script setup>
import ServicesIcon from "~/components/icons/wow/ServicesIcon.vue";
import ChevRight from "~/components/icons/ChevRight.vue";
import PvPIcon from "~/components/icons/wow/PvPIcon.vue";
import PvEIcon from "~/components/icons/wow/PvEIcon.vue";
import CollectionIcon from "~/components/icons/wow/CollectionIcon.vue";
import GoldIcon from "~/components/icons/wow/GoldIcon.vue";
import { ref, computed } from "vue";
import { useGtm } from "@gtm-support/vue-gtm";
import TpReviews from "~/components/common/sections/boosting/TpReviews.vue";
// HOOKS
const { t } = useI18n();
const { public: publicConfig } = useRuntimeConfig();
const { nuxtEnv } = publicConfig;
const $gtm = useGtm();
const { currentGameSlug, currentGamePackSlug } = useGameComposable();
const { isCrispLoaded, openChat, initializeCrisp } = useCrispComposable();

const { getGame } = useGameStore();
const userStore = useUserStore();
const router = useRouter();
const route = router.currentRoute;
const localePath = useLocalePath();
// REACTIVE
const isOpen = ref(false);
const currentOpenDrop = ref("");
const nuxtApp = useNuxtApp();

// COMPUTED
const gameCategories = computed(() => {
  if (getGame) {
    if (getGame?.categories?.length > 0) {
      return getGame?.categories;
    }
  }
  return [];
});

const contactText = computed(() => {
  return t("new.contact_us");
});

const allGamePacks = computed(() => {
  if (gameCategories.value?.length > 0) {
    const gamePacks = gameCategories.value.map((category) => category.packs);
    return gamePacks.flat();
  }
  return [];
});

const activePack = computed(() => {
  if (!route.value?.params?.gamePackSlug) {
    return t("new.services");
  }
  let key = "categoryPackSlug";
  if (route.value?.params?.gamePackSlug === "buy-wow-gold") {
    key = "gamePackSlug";
  }
  console.log("key", key);
  const packSlug = route.value.params[key];
  const activePacks = allGamePacks.value.find((pack) => pack.slug === packSlug);

  if (activePacks) {
    return activePacks.short_title;
  } else {
    const category = gameCategories.value?.find(
      (cate) => cate.slug === packSlug
    );
    if (category) {
      return category.short_title;
    }
  }
  return "";
});

const isNotCategoryPage = computed(() => {
  if (route.value.params?.categoryPackSlug) {
    return true;
  }
  return false;
});

const otherPacks = computed(() => {
  if (activePack.value !== t("new.services")) {
    let packs = allGamePacks.value.filter(
      (packs) =>
        packs.short_title !== activePack.value &&
        packs.slug !== "wow-raid-boost" &&
        packs.slug !== "wow-mounts-unlock" &&
        packs.slug !== "wow-transmog-unlock"
    );
    packs = [
      {
        short_title: t("new.services"),
        is_service: true,
      },
      ...packs,
    ];
    return packs;
  }
  if (activePack.value) {
    return allGamePacks.value.filter(
      (packs) =>
        packs.short_title !== activePack.value &&
        packs.slug !== "wow-raid-boost" &&
        packs.slug !== "wow-mounts-unlock" &&
        packs.slug !== "wow-transmog-unlock"
    );
  }

  return allGamePacks.value;
});
// METHODS
const categoryPack = (category) => {
  if (category?.packs?.length > 0) {
    return category.packs;
  }
  return [];
};
const toggleDrop = () => {
  isOpen.value = true;
};
const closeOutside = () => {
  if (isOpen.value) {
    isOpen.value = false;
  }
};

const getLinkMobile = (packSlug) => {
  const categorySlug = gameCategories.value.find((category) => {
    const packe = category.packs.find((pack) => pack.slug === packSlug);
    if (packe?.slug) {
      return true;
    } else if (
      packSlug === "wow-raid-boost" &&
      category.slug === "wow-pve-boost"
    ) {
      return true;
    }
    return false;
  });

  if (packSlug === "wow-custom-raid-boost") {
    return `/${currentGameSlug}/${categorySlug.slug}/wow-raid-boost`;
  }
  if (categorySlug.slug !== packSlug) {
    return localePath(`/${currentGameSlug}/${categorySlug.slug}/${packSlug}`);
  }

  return `/${currentGameSlug}/${packSlug}`;
  return "";
};

const sendDataLayer = (pack) => {
  if (nuxtEnv === "prod" && window.dataLayer?.push) {
    let otherParams = {};
    if (userStore.getUser.id) {
      otherParams = {
        user_data: {
          first_name: userStore.getUser.username,
          email_address: userStore.getUser.email,
          user_id: userStore.getUser.id,
          customer_lifetime_spent: userStore.getUser.total_spent,
        },
      };
    }
    window.dataLayer?.push({
      event: "select_item",
      ecommerce: {
        items: [
          {
            item_id: "game_pack_" + pack.id,
            item_name: pack.title,
            affiliation: pack.slug,
            quantity: 1,
          },
        ],
      },
      ...otherParams,
    });
  }
};

const isDropCategory = (category) => {
  if (
    ["wow-pve-boost", "wow-pvp-boost", "wow-collections"].includes(
      category.slug
    )
  ) {
    return true;
  }
  return false;
};

const getLink = (categorySlug, packSlug) => {
  if (packSlug === "wow-custom-raid-boost") {
    return localePath(`/${currentGameSlug}/${categorySlug}/wow-raid-boost`);
  }
  return localePath(`/${currentGameSlug}/${categorySlug}/${packSlug}`);
  // return "";
};

const openCategoryDrop = (categorySlug) => {
  if (currentOpenDrop.value === categorySlug) {
    currentOpenDrop.value = "";
    return;
  }
  currentOpenDrop.value = categorySlug;
};

const handleCategoryDrop = () => {
  // const gamePackSlug = this.$route?.params?.gamePackSlug;
  const categorySlug = gameCategories.value.find((category) => {
    const packe = category.packs.find(
      (pack) => pack.slug === currentGamePackSlug
    );
    if (packe?.slug) {
      return true;
    } else if (
      currentGamePackSlug === "wow-raid-boost" &&
      category.slug === "wow-pve-boost"
    ) {
      return true;
    }
    return false;
  });
  if (categorySlug) {
    currentOpenDrop.value = categorySlug?.slug;
  } else {
    const catSlug = gameCategories.value.find(
      (category) => category.slug === currentGamePackSlug
    );
    if (catSlug) {
      currentOpenDrop.value = catSlug?.slug;
    }
  }
};

const getComingSoon = (pack) => {
  if (
    pack.slug === "wow-mounts-unlock" ||
    pack.slug === "wow-transmog-unlock"
  ) {
    return true;
  }
  return false;
};
handleCategoryDrop();

const handleTidio = () => {
  if (isCrispLoaded()) {
    openChat();
  } else {
    initializeCrisp();
    openChat();
  }
};
</script>
